import { DashboardRequest } from "../../../models";
import BaseRepository from "../BaseRepository";

export class DashboardRepo extends BaseRepository{
    protected baseUrl = "dashboard";

    async postAsync<t=any>(request: DashboardRequest): Promise<any>{
        const response = await this.client.post(`${this.baseUrl}/${request.name}`, request);
        return this.handleResponse<t>(response);
    }
}
